import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26703fae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 0,
  class: "icon"
}
const _hoisted_4 = {
  key: 1,
  class: "description"
}

import { ref } from "vue";
import AppInput from "./AppInput.vue";

interface Props {
  /** two-way bound text state */
  modelValue?: string;
  /** whether field is multi-line */
  multi?: boolean;
  /** optional side icon */
  icon?: string;
  /** placeholder string when nothing typed in */
  placeholder?: string;
  /** name of field, shown above box */
  title?: string;
  /** description of field, shown below box */
  description?: string;
  /** whether field is required */
  required?: boolean;
  /** delay for debounce in ms */
  debounce?: number;
}

interface Emits {
  /** two-way bound text state */
  (event: "update:modelValue", value: string): void;
  /** when user types in box, after some delay */
  (event: "debounce", value: string): void;
  /** when user "commits" change (pressing enter, blurring, etc) */
  (event: "change", value: string): void;
  /** when input focused */
  (event: "focus"): void;
  /** when input blurred */
  (event: "blur"): void;
}


const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AppTextbox',
  props: {
    modelValue: null,
    multi: { type: Boolean },
    icon: null,
    placeholder: null,
    title: null,
    description: null,
    required: { type: Boolean },
    debounce: null
  },
  emits: ["update:modelValue", "debounce", "change", "focus", "blur"],
  setup(__props: any, { expose, emit }: { emit: ({
  /** two-way bound text state */
  (event: "update:modelValue", value: string): void;
  /** when user types in box, after some delay */
  (event: "debounce", value: string): void;
  /** when user "commits" change (pressing enter, blurring, etc) */
  (event: "change", value: string): void;
  /** when input focused */
  (event: "focus"): void;
  /** when input blurred */
  (event: "blur"): void;
}), expose: any, slots: any, attrs: any }) {





/** element reference */
const textbox = ref();
/** element reference */
const input = ref();

/** clear box */
function clear() {
  input.value.input.value = "";
  input.value.input.dispatchEvent(new Event("input"));
  emit("change", "");
}

/** allow parent to access ref */
expose({ textbox });

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.title) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createBlock(_component_AppIcon, {
                key: 0,
                icon: "asterisk",
                class: "asterisk"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "textbox",
      ref: textbox,
      class: "textbox"
    }, [
      _createVNode(AppInput, _mergeProps({
        ref_key: "input",
        ref: input,
        class: "input"
      }, _ctx.$attrs, {
        multi: __props.multi,
        "model-value": __props.modelValue,
        placeholder: __props.placeholder,
        required: __props.required,
        debounce: __props.debounce,
        "data-multi": !!__props.multi,
        "data-icon": !!__props.icon,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (...args) => _ctx.$emit('update:modelValue', ...args)),
        onDebounce: _cache[1] || (_cache[1] = (...args) => _ctx.$emit('debounce', ...args)),
        onChange: _cache[2] || (_cache[2] = (...args) => _ctx.$emit('change', ...args)),
        onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('focus'))),
        onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('blur')))
      }), null, 16, ["multi", "model-value", "placeholder", "required", "debounce", "data-multi", "data-icon"]),
      (!__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (__props.icon)
              ? (_openBlock(), _createBlock(_component_AppIcon, {
                  key: 0,
                  icon: __props.icon
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (__props.modelValue)
        ? _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
            key: 1,
            class: "icon",
            icon: "times",
            design: "small",
            onClickCapture: _withModifiers(clear, ["stop"])
          }, null, 8, ["onClickCapture"])), [
            [_directive_tooltip, 'Clear text']
          ])
        : _createCommentVNode("", true)
    ], 512),
    (__props.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})